import React, { useContext, useState } from 'react';
import { Alert, Box, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { UserContext } from '../auth/auth-context';
import { START_PAGES, readStartPage, saveStartPage } from '../../util/startPage';

export default function StartPageControl({ sx, textSx }) {
  const { providerUser } = useContext(UserContext);
  const [anchor, setAnchor] = useState(null);
  const [selected, setSelected] = useState(() => readStartPage(providerUser?.userId) || (providerUser?.defaultBusinessId ? 'bookingTypes' : 'workspaces'));
  const [error, setError] = useState(false);
  return <>
    <ListItem button sx={sx} aria-label="Start page" aria-haspopup="menu" aria-expanded={Boolean(anchor)}
      onClick={event => { setSelected(readStartPage(providerUser?.userId) || (providerUser?.defaultBusinessId ? 'bookingTypes' : 'workspaces')); setError(false); setAnchor(event.currentTarget); }}>
      <ListItemIcon><HomeOutlinedIcon sx={{ fontSize: 19 }} /></ListItemIcon>
      <ListItemText primary="Start page" secondary={START_PAGES.find(page => page.id === selected)?.label} sx={textSx} />
    </ListItem>
    <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} PaperProps={{ sx: { minWidth: 245, borderRadius: 2 } }}>
      <Box sx={{ px: 2, py: 1 }}><Typography variant="subtitle2">Open after sign-in</Typography><Typography variant="caption" color="text.secondary">Saved for your account in this browser.</Typography></Box>
      {START_PAGES.filter(page => !page.workspace || providerUser?.defaultBusinessId).map(page => <MenuItem key={page.id}
        role="menuitemradio" aria-checked={selected === page.id} selected={selected === page.id}
        onClick={() => { if (saveStartPage(providerUser?.userId, page.id)) { setSelected(page.id); setAnchor(null); } else setError(true); }}>
        <ListItemText>{page.label}</ListItemText>{selected === page.id && <CheckRoundedIcon fontSize="small" sx={{ ml: 2 }} />}
      </MenuItem>)}
      {error && <Alert severity="error">Could not save this preference. Check your browser storage settings.</Alert>}
    </Menu>
  </>;
}
